import { createSliceSelectors } from '../utils'

const PaymentSelectors = createSliceSelectors('payments', ['isPaymentModalOpen', 'isPaymentHotspotHovered'])

export default PaymentSelectors
